import { Box, Hidden, IconButton, Slide, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { SidebarLinks } from "./SidebarLinks";
import { useDispatch, useSelector } from "react-redux";
import { setMenuOpen } from "../../store/MenuSlice";
import { IoMdClose } from "react-icons/io";

export default function Sidebar() {
  const [menuItems, setMenuItems] = useState(SidebarLinks);
  const navigate = useNavigate();
  const drawerWidth = 100;
  const menu = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState({
    title: "Почетна",
    icon: <AiOutlineHome />,
  });

  return (
    <Box
      sx={{
        width: `${drawerWidth}px`,
        height: "100vh",
        background:
          "linear-gradient(135deg, rgb(4, 85, 152), rgb(0, 112, 204))",
        display: {
          xs: menu?.open ? "flex" : "none", // hidden on phones
          sm: "flex", // hidden on tablets
          md: "flex", // visible on desktop and up
        },
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Hidden mdUp>
        <IconButton
          onClick={() => dispatch(setMenuOpen(false))}
          sx={{ color: "white", alignSelf: "center", margin: 1 }}
        >
          <IoMdClose fontSize={32} />
        </IconButton>
      </Hidden>

      {menuItems.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            marginTop: index === 0 ? "100px" : 0,
            cursor: "pointer",
            userSelect: "none",
            padding: "4px",
            width: 85,
            height: 75,
            boxSizing: "border-box",
            backgroundColor:
              selectedItem.title === item.title
                ? "rgba(231, 231, 231, 0.2)"
                : "",
            borderRadius: selectedItem.title === item.title ? "3px" : "",
            "&:hover": {
              borderRadius: "3px",
              backgroundColor: "rgba(231, 231, 231, 0.2)",
            },
          }}
          onClick={() => {
            setSelectedItem(item);
            dispatch(setMenuOpen(false));
            navigate(item.path || "/");
          }}
        >
          {React.cloneElement(
            selectedItem.title === item.title ? item.selectedIcon : item.icon,
            {
              size: 23,
              color: selectedItem.title === item.title ? "#e59900" : "white",
            }
          )}

          <Typography
            variant="body2"
            align="center"
            sx={{
              whiteSpace: "pre-line",
              marginTop: 1,
              fontSize: "14px",
              fontFamily: "Inter-Regular",
              letterSpacing: "0.2px",
              lineHeight: "1.2",
            }}
          >
            {(() => {
              const words = item.title.split(" ");
              const mid = Math.ceil(words.length / 2);
              const firstLine = words.slice(0, mid).join(" ");
              const secondLine = words.slice(mid).join(" ");
              return `${firstLine}\n${secondLine}`;
            })()}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
